// services/plaidService.js
import { HttpApiClient } from "../axios/axiosInstance";

const PLAID_ENDPOINTS = {
  createLinkToken: "/plaid/link/token",
  exchangeToken: "/plaid/link/exchange",
  accounts: "/plaid/accounts",
  syncTransactions: (accountId) => `/plaid/accounts/${accountId}/sync`,
  disconnectAccount: (accountId) => `/plaid/accounts/${accountId}`,
};

// Create link token for Plaid Link initialization
export const createLinkToken = async () => {
  try {
    const response = await HttpApiClient.post(PLAID_ENDPOINTS.createLinkToken);

    // Access nested payload structure
    const { payload } = response.data;
    return payload;
  } catch (error) {
    console.error("Error creating link token:", error);
    throw new Error(
      error.response?.data?.message || "Failed to create link token"
    );
  }
};

// Exchange public token for access token and store account data
export const exchangePublicToken = async (publicToken, metadata) => {
  try {
    const response = await HttpApiClient.post(PLAID_ENDPOINTS.exchangeToken, {
      public_token: publicToken,
      metadata: metadata,
    });

    // Access nested payload structure
    const { payload } = response.data;
    return payload;
  } catch (error) {
    console.error("Error exchanging public token:", error);
    throw new Error(
      error.response?.data?.message || "Failed to connect bank account"
    );
  }
};

// Get user's connected bank accounts
export const getConnectedAccounts = async () => {
  try {
    const response = await HttpApiClient.get(PLAID_ENDPOINTS.accounts);

    // Access nested payload structure
    const { payload } = response.data;
    return payload;
  } catch (error) {
    console.error("Error fetching connected accounts:", error);
    throw new Error(
      error.response?.data?.message || "Failed to fetch bank accounts"
    );
  }
};

// Sync transactions for a specific account
export const syncAccountTransactions = async (accountId, options = {}) => {
  try {
    const response = await HttpApiClient.post(
      PLAID_ENDPOINTS.syncTransactions(accountId),
      options
    );

    // Access nested payload structure
    const { payload } = response.data;
    return payload;
  } catch (error) {
    console.error("Error syncing transactions:", error);
    throw new Error(
      error.response?.data?.message || "Failed to sync transactions"
    );
  }
};

// Disconnect a bank account
export const disconnectBankAccount = async (accountId) => {
  try {
    const response = await HttpApiClient.delete(
      PLAID_ENDPOINTS.disconnectAccount(accountId)
    );

    // Access nested payload structure
    const { payload } = response.data;
    return payload;
  } catch (error) {
    console.error("Error disconnecting account:", error);
    throw new Error(
      error.response?.data?.message || "Failed to disconnect account"
    );
  }
};

// Refresh all connected accounts
export const refreshAllAccounts = async () => {
  try {
    const accounts = await getConnectedAccounts();
    const refreshPromises = accounts.map((account) =>
      syncAccountTransactions(account.id).catch((err) => {
        console.warn(`Failed to refresh account ${account.id}:`, err.message);
        return null;
      })
    );

    await Promise.all(refreshPromises);
    return await getConnectedAccounts(); // Return updated accounts
  } catch (error) {
    console.error("Error refreshing accounts:", error);
    throw new Error("Failed to refresh accounts");
  }
};
